module.exports = __webpack_public_path__ + "static/media/line.09ec50dc.jpg";